import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {HeaderCashierButtonBox} from "./boxes/header-cashier-button.box";
import {getButtonSizeVariant} from "../../welcome-buttons/header-welcome-buttons-helpers";
import React from "react";
import {CyClass} from "../../../../../common/cy-classes";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";
import {CashierSessionTypes} from "../../../../../common/const/cashier-session-types";

@observer
export class HeaderCashierButtonComponent extends OrbitComponent {
    private _onCashierClick = async () => {
        await this.services.cashier.openCashier({
            sessionType: CashierSessionTypes.FULL_CASHIER,
            channel: {
                source: CHANNEL_SOURCE.casinoClient,
                area: AreaType.Header,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });
    }
    render() {
        return (
            <HeaderCashierButtonBox preset="primary" className={CyClass('cy-welcome-cashier-button')}
                                    sizeVariant={getButtonSizeVariant(this.services)}
                                    onClick={this._onCashierClick}>
                {this.services.translation.translate('CASHIER')}
            </HeaderCashierButtonBox>
        )
    }
}